<template>
	<div class="mb-3">
		<label class="form-label small">{{ item.label }}</label>
		<div class="d-flex gap-2">
			<input
				type="date"
				:value="dateRange.start"
				@input="updateStartDate"
				class="form-control form-control-sm"
				placeholder="Start date"
			/>
			<input
				type="date"
				:value="dateRange.end"
				@input="updateEndDate"
				class="form-control form-control-sm"
				placeholder="End date"
			/>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DateRangeItem',
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
	computed: {
		dateRange() {
			if (typeof this.item.value === 'string') {
				const [start, end] = this.item.value.split(',')
				return { start: start || '', end: end || '' }
			}
			return this.item.value || { start: '', end: '' }
		},
	},
	methods: {
		updateStartDate(event) {
			const newRange = { ...this.dateRange, start: event.target.value }
			this.emitRange(newRange)
		},
		updateEndDate(event) {
			const newRange = { ...this.dateRange, end: event.target.value }
			this.emitRange(newRange)
		},
		emitRange(range) {
			// Emit as "start,end" string or as object based on preference
			const value = range.start || range.end ? `${range.start},${range.end}` : ''
			this.$emit('update', value)
		},
	},
}
</script>
